<template>
  <div class="ops-page">
    <div class="table-head">
      <span class="table-title">种花发布</span>
      <Button type="primary" disabled>发布</Button>
    </div>
    <Alert type="warning" show-icon>
      接口待补充，暂不可用。管理端发布接口就绪后再开放操作。
    </Alert>
    <Table :columns="columns" :data="[]" />
  </div>
</template>

<script>
export default {
  name: 'OpsFlowerPublish',
  data() {
    return {
      columns: [
        { title: '序号', key: 'index', width: 70 },
        { title: '名称', key: 'title', minWidth: 160 },
        { title: '状态', key: 'status', width: 100 },
        { title: '更新时间', key: 'updated_at', width: 170 },
        { title: '操作', key: 'action', width: 120 },
      ],
    }
  },
}
</script>

<style scoped>
.ops-page {
  padding: 16px;
}

.table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.table-title {
  font-weight: bold;
  font-size: 16px;
}
</style>
